import React, { Component } from 'react';
import Select from 'react-select';
import ReactDOM from 'react-dom';
import ReactModal from 'react-modal';
import '../assets/teachers.css';
import {Tooltip, Popover, OverlayTrigger, Overlay} from 'react-bootstrap';
import REST from '../Shared/REST';
import HeaderComponent from '../Shared/Header';
import { withRouter, Redirect } from 'react-router-dom';
import ico_view from "../assets/images/ico_view.png";
import ico_plus_green from "../assets/images/ico_plus_green.png";
import ico_x from "../assets/images/modal_x_red.png";
import How_to_select_apps from "../assets/images/How to select apps.png";
import Helpers from "../Shared/Helpers";
import {connect} from "react-redux";
import {
    selectClass,
    selectStudentScoreListTab,
    selectStudentTab,
    updateStudent,
    updateTeacher,
    userLogout
} from "./actions";
import EmailConsentForm from "../ModalFormComponents/EmailConsentForm";
import FooterComponent from "../Shared/Footer";
import DialogBox from "../Shared/DialogBox";
import TRACKING from "../Shared/DataTrackingPoints";
import {VERSION} from '../Shared/Consts';
import logo_wordsignsay from "../assets/images/app-wordsignsay.png";
import ico_view_1 from "../assets/images/ico_view_1.png";
import App_Selection_Graphic from "../assets/images/App_Selection_Graphic.png";
import info_icon_2f from "../assets/images/info_icon_2f.png";
import logo_picturenaming from "../assets/images/app-picturenaming.png";
import logo_copyright from "../assets/images/app-copyright.png";
import logo_kidspeak from "../assets/images/logo_kidspeak.png";
import logo_maze from "../assets/images/logo_maze.png";
import logo_wordmark from "../assets/images/logo_wordmark.png";
import logo_slashtest from "../assets/images/logo_slashtest.png";
import logo_kidsign from "../assets/images/app-kidsignsay.png";
import ReactToPrint from 'react-to-print';
import ComponentToPrint from './ComponentToPrint';


const customStyle = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        width: '80%'
    }
};
const tooltipReadingLevel = (
    <Tooltip id="tooltipReadingLevel">
        Estimate Reading Grade Level. Add the reading grade versus placement grade.
    </Tooltip>
);

const tooltipDisability = (
    <Tooltip id="tooltipDisability">
        Multiple Select Option
    </Tooltip>
);
let tooltipSelectClass = (
    <Tooltip id="tooltipDisability">
        Select a class to view students
    </Tooltip>
);
const popoverAddClass = (
    <Popover id="popover-positioned-top" title="Step 1">
        Add a Class
    </Popover>
);
const popoverAddStudent = (
    <Popover id="popover-positioned-top" title="Step 2">
        Add a Student(s)
    </Popover>
);

let addClassStorage = localStorage.getItem('addClass');
let addStudentStorage = localStorage.getItem('addStudent');
let notice1Storage = localStorage.getItem('notice1');
let notice2Storage = localStorage.getItem('notice2');
let notice3Storage = localStorage.getItem('notice3');

let addClassInstruction = null;
let addStudentInstruction = null;
let PNInstruction = null;
let WSSInstruction = null;
let CopyrightInstruction = null;
let KidsignInstruction = null;
let KidspeakInstruction = null;

const readingLevelOptions = [
    { value: '0', label: '0' },
    { value: '1', label: '1' },
    { value: '2', label: '2' },
    { value: '3', label: '3' },
    { value: '4', label: '4' },
    { value: '5', label: '5' },
    { value: '6', label: '6' },
];

const genderOptions = [
    { value: '1', label: 'Female' },
    { value: '2', label: 'Male' },
    { value: '3', label: 'Other' }
];

const languageOptions = [
    { value: '1', label: 'ASL' },
    { value: '2', label: 'Signed English' },
    { value: '3', label: 'Spoken English' },
    { value: '5', label: 'Sim-com' },
    { value: '4', label: 'Other' }
];

let disabilityOptions = [
    { value: '1', label: 'None' },
    { value: '2', label: 'Deaf' },
    { value: '3', label: 'Hard of Hearing' },
    { value: '4', label: 'Blind / Visually impaired' },
    { value: '5', label: 'Learning Disability' },
    { value: '6', label: 'Behavior Challenges' },
    { value: '7', label: 'Developmental Challenges' },
    { value: '8', label: 'Physical Challenges' }
];

const placementOptions = [

    { value: '1', label: 'General Ed' },
    { value: '2', label: 'Special Classroom' },
    { value: '3', label: 'Resource Room' },
    { value: '4', label: 'School for the Deaf' }

];

const gradeOptions = [
    { value: '0', label: 'K' },
    { value: '1', label: '1' },
    { value: '2', label: '2' },
    { value: '3', label: '3' },
    { value: '4', label: '4' },
    { value: '5', label: '5' },
    { value: '6', label: '6' },
    { value: '7', label: '7' },
    { value: '8', label: '8' },
    { value: '9', label: '9' },
    { value: '10', label: '10' },
    { value: '11', label: '11' },
    { value: '12', label: '12' },
    { value: 'Transition', label: 'Transition' },
    { value: 'College', label: 'College' }

];

const fourValueOptions = [
    { value: '0', label: 'No' },
    { value: '1', label: 'Yes' },
    { value: '2', label: 'Unknown' }

];

let appOptions = [

    { value: 'picturenaming', label: 'PictureNaming', isSelected: true},
    { value: 'wordsignsay', label: 'WordSign/Say', isSelected: true},
    { value: 'copyright', label: 'CopyRight', isSelected: true},
    { value: 'slash', label: 'Slash', isSelected: true},
    { value: 'kidspeak', label: 'KidSpeak', isSelected: true},
    { value: 'maze', label: 'Maze', isSelected: true},
    { value: 'kidsign', label: 'KidSign/Say', isSelected: true},
    { value: 'wordmark', label: 'WordMark', isSelected: true},

];

let getValue = (opts, val) => opts.find(o => o.value === val);
let getChecked = (checkList, studentId) => {
    let student = checkList.find(o => o.studentId === studentId);
    if(student){
        return student.checked;
    }else{
        return null;
    }
}
let getFourValue = (opts, val) => {
    if (val === '-1') return null;
    else opts.find(o => o.value === val);
}
let resultMultipleValues = [];

let newVersion;


class MainTeacherComponent extends Component {

    constructor(props) {
        super(props);
        this.state = { classes: [],
            class: {},
            classStudents: [],
            student: {},
            addClass: false,
            showClass: false,
            showStudent: false,
            newStudent: false ,
            clickedClassId:-1,
            modalDialog: false,
            responseContent:'',
            showAddClassHint:true, showNotice:true, showNotice1: true, showNotice2: true, showNotice3: false, showNotice4: true,
            versionConflict: false,
            analytics: {
                type: null,
                metadata: null
            }};
        this.handleAddClass = this.handleAddClass.bind(this);
        this.handleClassItemClick = this.handleClassItemClick.bind(this);
        this.handleDeleteStudent = this.handleDeleteStudent.bind(this);
        this.handleDeleteClass = this.handleDeleteClass.bind(this);
        this.handleToggleAddClassHint = this.handleToggleAddClassHint.bind(this);
        this.getTarget = this.getTarget.bind(this);
        this.handleAnalytics = this.handleAnalytics.bind(this);
        this.handleSurveyBack = this.handleSurveyBack.bind(this);
        this.handleCloseNotice1 = this.handleCloseNotice1.bind(this);
        this.handleCloseNotice2 = this.handleCloseNotice2.bind(this);
        this.handleCloseNotice3 = this.handleCloseNotice3.bind(this);
        this.handleCloseNotice4 = this.handleCloseNotice4.bind(this);
        this.handleShowAllNotice = this.handleShowAllNotice.bind(this);
        this.handleShowNotice1 = this.handleShowNotice1.bind(this);
        this.handleShowNotice2 = this.handleShowNotice2.bind(this);
        this.handleShowNotice3 = this.handleShowNotice3.bind(this);
        this.handleShowNotice4 = this.handleShowNotice4.bind(this);
    }

    async componentDidMount() {
        Helpers.authorize(this);

        this.listClasses();

        await REST.getVersion().then(async response => {
            newVersion = response.body;

            if (newVersion !== VERSION) {
                await this.setState({showNotice3: true, versionConflict: true});
            };
        });

        if(localStorage.getItem('addClass') === 'hide'){
            this.setState({showAddClassHint: false})
        }
        if(localStorage.getItem('notice1') === 'hide'){
            this.setState({showNotice1: false})
        }
        if(localStorage.getItem('notice2') === 'hide'){
            this.setState({showNotice2: false})
        }
        if(!this.state.versionConflict & localStorage.getItem('notice3') === 'hide'){
            this.setState({showNotice3: false})
        }


        if(this.props.lastClass){
            this.handleClassItemClick(this.props.lastClass);
            if(this.props.lastStudent){
                this.handleStudentClick(this.props.lastStudent,this.props.lastClass.id)
            }
        }
    }

    handleAnalytics(){
        let analytics = this.state.analytics;
        REST.addAnalytics(analytics).then(res => {});
    }

    handleCloseNotice1(){
        this.setState({showNotice1: false});
        localStorage.setItem('notice1', 'hide');
    }

    handleCloseNotice2(){
        this.setState({showNotice2: false});
        localStorage.setItem('notice2', 'hide');
    }

    handleCloseNotice3(){
        this.setState({showNotice3: false});
        localStorage.setItem('notice3', 'hide');
    }

    handleCloseNotice4(){
        this.setState({showNotice4: false});
        localStorage.setItem('notice4', 'hide');
    }

    handleShowAllNotice(){
        if (this.state.versionConflict) {
            this.setState({showNotice1: true, showNotice2: true, showNotice3: true, showNotice4: true});
            localStorage.setItem('notice1', 'show');
            localStorage.setItem('notice2', 'show');
            localStorage.setItem('notice3', 'show');
            localStorage.setItem('notice4', 'show');
        }else{
            this.setState({showNotice1: true, showNotice2: true, showNotice3: false, showNotice4: true});
            localStorage.setItem('notice1', 'show');
            localStorage.setItem('notice2', 'show');
            localStorage.setItem('notice3', 'hide');
            localStorage.setItem('notice4', 'show');
        }
    }

    handleShowNotice1(){
        this.setState({showNotice1: true});
        localStorage.setItem('notice1', 'show');
    }

    handleShowNotice2(){
        this.setState({showNotice2: true});
        localStorage.setItem('notice2', 'show');
    }

    handleShowNotice3(){
        this.setState({showNotice3: true});
        localStorage.setItem('notice3', 'show');
    }

    handleShowNotice4(){
        this.setState({showNotice4: true});
        localStorage.setItem('notice4', 'show');
    }

    handleToggleAddClassHint(){
        this.setState({ showAddClassHint: false});
    }
    getTarget() {
        return ReactDOM.findDOMNode(this.target);
    }

    handleAddClass() {
        this.setState({ showClass: false, showNotice:false, addClass: !this.state.addClass, showStudent: false, newStudent: false });
        this.handleToggleAddClassHint();
        localStorage.setItem('addClass', 'hide');
    }

    handleCancel = () => {
        this.setState({ showClass: false, addClass: false, showStudent: false, newStudent: false });
        this.props.selectClass(null);
        this.props.updateStudent(null);
    };

    handleNewClassCallback = (classObject) => {
        let classes = this.state.classes;
        classes.push(classObject);
        this.setState({ classes: classes });
        this.handleClassItemClick(classes[classes.length-1]);
        this.setState({
                analytics: {
                    type: TRACKING.TEACHER_ADDED_CLASS,
                    metadata: {classId: classObject.id, className: classObject.name},
                }
            },
            ()=>this.handleAnalytics())
    };

    handleDeleteStudent(student){
        REST.deleteStudent(student.userId,this.props.lastClass.id).then(res => {
            this.handleClassItemClick(this.props.lastClass);
            this.setState({
                    analytics: {
                        type: TRACKING.TEACHER_STUDENT_DELETE,
                        metadata: {userId: student.user.id, firstName: student.user.firstname, lastName: student.user.lastname},
                    }
                },
                ()=>this.handleAnalytics())
        });
    }

    handleDeleteClass(theclass){
        REST.deleteClass(theclass.id).then(async res => {
            await this.handleCancel();
            await this.listClasses();
        });
    }

    handleClassItemClick = (object) => {
        this.handleCancel();
        REST.listStudents(object.id).then((response) => {
            if (response.success) {
                let res = response.body;
                this.setState({ showClass: true, classStudents: res, class: object, newStudent: false, showNotice:false, showStudent: false, clickedClassId:object.id });
                this.props.selectClass(object);
                this.setState({
                        analytics: {
                            type: TRACKING.TEACHER_SELECT_CLASS,
                            metadata: {classId:object.id, className: object.name},
                        }
                    },
                    ()=>this.handleAnalytics())
            }
            else {
                this.setState({
                    modalDialog: true,
                    responseContent:response.msg

                });
                setTimeout(()=>{this.setState({modalDialog:false})},3500);
            }
        }, (error) => {
            console.log('Error', error.msg);
        });
    };

    handleLogout = () => {
        REST.logout().then(async (response) => {
            if (response.success) {
                this.props.callback({});
                if(localStorage.getItem('addClass') === 'hide'){
                    addClassInstruction = localStorage.getItem('addClass');
                }
                if(localStorage.getItem('addStudent') === 'hide'){
                    addStudentInstruction = localStorage.getItem('addStudent');
                }
                localStorage.removeItem('token');
                if(addClassInstruction !== null){
                    localStorage.setItem('addClass',addClassInstruction);
                }
                if(addStudentInstruction !== null){
                    localStorage.setItem('addStudent',addStudentInstruction);
                }
                await this.props.persistor.purge();
                await this.props.userLogout();
                this.props.history.push("/");
            }
            else {
                this.setState({
                    modalDialog: true,
                    responseContent:response.msg

                });
                setTimeout(()=>{this.setState({modalDialog:false})},3500);
            }
        }, (error) => {
            this.setState({
                modalDialog: true,
                responseContent:error.msg

            });
            setTimeout(()=>{this.setState({modalDialog:false})},3500);
        });
    };

    handleUpdateClass = (object) => {
        this.handleCancel();
        this.setState({
                analytics: {
                    type: TRACKING.TEACHER_UPDATED_CLASS,
                    metadata: {classId: object.id, className: object.name},
                }
            },
            ()=>this.handleAnalytics())
        this.setState({ classes: [] });
        this.listClasses();
    };

    handleStudentClick = (student, classId) => {
        this.props.handleStudentClick(student, classId);
        this.props.updateStudent(student);
        this.props.history.push('/teacher/student');
    };

    handleAddStudent = (classId) => {
        this.setState({ newStudent: true, showNotice:false, addClass: false, showClass: false });
    };

    listClasses() {
        REST.classList().then((response) => {
            if (response.success) {
                this.setState({ classes: response.body });
            }
            else {
                this.setState({
                    modalDialog: true,
                    responseContent:response.msg

                });
                setTimeout(()=>{this.setState({modalDialog:false})},3500);
            }
        }, (error) => {
            this.setState({
                modalDialog: true,
                responseContent:error.msg

            });
            setTimeout(()=>{this.setState({modalDialog:false})},3500);
        });
    }

    async handleSurveyBack(){
    }

    render() {
        const sharedProps = {
            container: this,
            target: this.getTarget,
            show: this.state.showAddClassHint
        };
        return (
            <div>
                <HeaderComponent logout={this.handleLogout} teacherId={this.props.teacher&&this.props.teacher.id?this.props.teacher.id:null} notifications bugReport studentClick={this.handleStudentClick}/>
                <div className="section bgGrey">
                    <div className="container">
                        <DialogBox notificationModal modalOpen={this.state.modalDialog} sectionContent={this.state.responseContent} closeClick={(active)=>{this.setState({modalDialog: active});}} />
                        <DialogBox surveyModal role={'teacher'} app={'Homepage'} userId={this.props.teacher&&this.props.teacher.id?this.props.teacher.id:null} active={true} surveyBack={this.handleSurveyBack}/>
                        <div className="row">
                            <div className="col-md-3">
                                <div className={"row"}>
                                    <div className={'col-md-10'}>
                                        <h1 className="fl">My Classes</h1>
                                    </div>
                                    <div className={'col-md-2'}>
                                        <a ref={button => {
                                            this.target = button;
                                        }} className="fr">
                                            <img src={ico_plus_green}  onClick={this.handleAddClass} alt="Add a Class" border="0" className="ico-xs ico-add" />
                                        </a>
                                        {
                                            addClassStorage !== 'hide' ?
                                                <Overlay {...sharedProps} placement="top">
                                                    <Popover id="popover-positioned-top" title="Step 1">
                                                        Add a Class
                                                    </Popover>
                                                </Overlay>
                                                :
                                                null
                                        }
                                    </div>
                                </div>
                                <div className="col-lg-12 solidBorder noPadding">
                                    <ClassListComponent
                                        classes={this.state.classes}
                                        handleItemClick={this.handleClassItemClick}
                                        clickedClassID={this.state.clickedClassId}
                                        deleteClass={this.handleDeleteClass}
                                    />
                                </div>
                            </div>
                            {
                                this.state.addClass ? (
                                        <div className="col-md-9 container navbar-container">
                                            <h1>Add Class</h1>
                                            <AddClassComponent edit={false} cancelCallback={this.handleCancel} saveClassCallback={this.handleNewClassCallback} />
                                        </div>)
                                    :
                                    null
                            }
                            {
                                this.state.showClass ?
                                    <ClassNavigation
                                        class={this.state.class}
                                        students={this.state.classStudents}
                                        handleAddStudent={this.handleAddStudent}
                                        studentClick={this.handleStudentClick}
                                        updateClassCallback={this.handleUpdateClass}
                                        deleteStudent={this.handleDeleteStudent}
                                    />
                                    :
                                    null
                            }

                            {
                                this.state.showNotice ?
                                    <div id="popover-positioned-bottom" className="col-md-9 container navbar-container" title="Notice" >
                                        <div><h1>Notice</h1>{this.state.showNotice1?<div className={"showNotice"}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>:
                                            <div className={"showNotice"} onClick={this.handleShowAllNotice}>[show all]</div>
                                        }</div>
                                        {this.state.showNotice2?
                                            <div className={"noticeBox"} style={{marginTop:10}}>
                                                <div className={"noticeTitle"}>WordMark2</div>
                                                <div className={"noticeClose"} onClick={this.handleCloseNotice2}><img className={"noticeCloseIcon"} src={ico_x} alt={"Close"}/></div>
                                                <div className={"noticeContent"}>
                                                    Have your students tried WordMark2? We have created a new version of WordMark that we think your students will love. They will find it in their list of apps that appear when they logon.
                                                </div>
                                            </div>
                                            :null}
                                        {this.state.showNotice4?
                                            <div className={"noticeBox"} style={{marginTop:135}}>
                                                <div className={"noticeTitle"}>Sharing and transferring students has been moved </div>
                                                <div className={"noticeClose"} onClick={this.handleCloseNotice4}><img className={"noticeCloseIcon"} src={ico_x} alt={"Close"}/></div>
                                                <div className={"noticeContent"}>
                                                    We've moved the SHARE/ TRANSFER student feature. When you select your class, notice the SHARE/ TRANSFER tab at the top of the screen and follow the instructions.
                                                </div>
                                            </div>
                                            :null}
                                        {this.state.showNotice1?
                                            <div className={"noticeBox"} style={{marginTop:260}}>
                                                <div className={"noticeTitle"}>Parent Feature</div>
                                                <div className={"noticeClose"} onClick={this.handleCloseNotice1}><img className={"noticeCloseIcon"} src={ico_x} alt={"Close"}/></div>
                                                <div className={"noticeContent"}>
                                                    To add a parent account, enter a parent's email address in the Student Details page. The parent will receive account information and access to their student's data charts (but not the teacher notes). Look in the Resources tab on the login page for more details.
                                                </div>
                                            </div>
                                            :null}

                                        {this.state.showNotice3?
                                            <div className={"noticeBox"} style={{marginTop:405}}>
                                                <div className={"noticeTitle"}>Version Conflict </div>
                                                <div className={"noticeClose"} onClick={this.handleCloseNotice3}><img className={"noticeCloseIcon"} src={ico_x}/></div>
                                                <div className={"noticeContent"}>
                                                    The current version of the website on your computer (v.{VERSION}) is behind the newest version (v.{newVersion}). Please clean your browser cache and refresh the page.<br/>
                                                    * If you are using Chrome (Mac), please click on the 'Chrome' menu and select 'Clean Browsing Data'. Then click on the 'Clear Data' button.<br/>
                                                    * If you are using FireFox (Mac), please click on the 'History'. Choose the select box 'time range to clear' as 'Everything' and then click on 'OK'.<br/>
                                                </div>
                                            </div>
                                            :null}

                                    </div>
                                    :
                                    null
                            }
                            {
                                this.state.newStudent ?
                                    <AddStudent class={this.state.class} classId={this.state.class.id} handleCancel={this.handleCancel} handleClassItemClick={this.handleClassItemClick}/>
                                    :
                                    null
                            }
                        </div>
                    </div>
                </div>
                {this.props.teacher && !this.props.teacher.teacher.consent ?
                    <EmailConsentForm updateTeacher={this.props.updateTeacher} teacher={this.props.teacher}/>
                    : null
                }
                <FooterComponent/>
            </div>
        );
    }
}

export class ClassNavigation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            class: this.props.class,
            listStudents: true,
            listMultipleStudents: false
            };
        this.handleStudentsTab = this.handleStudentsTab.bind(this);
        this.handleMultipleStudentsTab = this.handleMultipleStudentsTab.bind(this);
        this.handleClassTab = this.handleClassTab.bind(this);
    }

    handleStudentClick = (student, classId) => {
        this.props.studentClick(student, classId);
    }

    handleAddStudent = () => {
        this.props.handleAddStudent(this.state.class.id);
    }

    handleStudentsTab(event) {
        this.setState({ listStudents: true, listMultipleStudents: false });
        event.preventDefault();
    }

    handleMultipleStudentsTab(event) {
        this.setState({ listStudents: false, listMultipleStudents: true});
        event.preventDefault();
    }

    handleClassTab(event) {
        this.setState({ listStudents: false, listMultipleStudents: false  });
        // event.preventDefault();
    }

    handleCancel = () => {
        this.setState({ listStudents: true, listMultipleStudents: false   });
    }

    handleUpdateClass = (object) => {
        this.props.updateClassCallback(object);
    }

    listStudents() {
        REST.listStudents(this.props.class.id).then((response) => {
            if (response.success) {
                this.setState({ students: response.body });
            }
            else {
                this.setState({
                    modalDialog: true,
                    responseContent:response.msg

                });
                setTimeout(()=>{this.setState({modalDialog:false})},3500);
            }
        }, (error) => {
            console.log('List students error', error);
            this.setState({
                modalDialog: true,
                responseContent:error.msg

            });
            setTimeout(()=>{this.setState({modalDialog:false})},3500);
        });
    }

    render() {
        return (
            <div className="col-md-9">
                {this.state.listStudents ?
                    (
                        <Students
                            handleClassTab={this.handleClassTab}
                            handleMultipleStudentsTab={this.handleMultipleStudentsTab}
                            classId={this.state.class.id}
                            handleAddStudent={this.handleAddStudent}
                            students={this.props.students}
                            handleItemClick={this.handleStudentClick}
                            deleteStudent={this.props.deleteStudent}
                        />
                    ) :this.state.listMultipleStudents? (
                            <MultipleStudents
                                handleStudentsTab = {this.handleStudentsTab}
                                handleClassTab={this.handleClassTab}
                                classId={this.state.class.id}
                                handleAddStudent={this.handleAddStudent}
                                students={this.props.students}
                                handleItemClick={this.handleStudentClick}
                                deleteStudent={this.props.deleteStudent}
                            />
                        ):
                    (
                        <div>
                            <ul className="nav nav-tabs">
                                <li onClick={this.handleStudentsTab}><a data-toggle="tab">Students</a></li>
                                <li className="active" onClick={this.handleClassTab}><a data-toggle="tab">Class Info</a></li>
                                <li onClick={this.handleMultipleStudentsTab}><a data-toggle="tab">Share/Transfer Students</a></li>
                            </ul>
                            <div className="tab-content">
                                <AddClassComponent edit={true} class={this.state.class} cancelCallback={this.handleCancel} saveClassCallback={this.handleUpdateClass} />
                            </div>
                        </div>
                    )
                }
            </div>
        );
    }
}

class AddStudentComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            firstname: '',
            lastname: '',
            email: null,
            gender: null,
            language: null,
            disability: null,
            placement: null,
            gradeLevel: null,
            specialNeedsData: '-1',
            freeLunch: '-1',
            ell: '-1',
            title1: '-1',
            research: true,
            screeningLevel: null,
            firstNameError: '',
            lastNameError: '',
            readingLevelError: '',
            genderError: '',
            languageError: '',
            disabilityError: '',
            placementError: '',
            gradeError: '',
            emailWarning: '',
            errorEmail: '',
            errorNote: '',
            apps:"picturenaming,wordsignsay,copyright,slash,kidsign,kidspeak,maze,wordmark",
            excludeVid:false,
            multipleValues: [],
            showAppIntro:false
        };
        this.handleName = this.handleName.bind(this);
        this.handleLastName = this.handleLastName.bind(this);
        this.handleEmail = this.handleEmail.bind(this);
        this.handleReadingLevel = this.handleReadingLevel.bind(this);
        this.handleGender = this.handleGender.bind(this);
        this.handleLanguage = this.handleLanguage.bind(this);
        this.handleFreeLunch = this.handleFreeLunch.bind(this);
        this.handleELL = this.handleELL.bind(this);
        this.handlePlacement = this.handlePlacement.bind(this);
        this.handleSpecialEd = this.handleSpecialEd.bind(this);
        this.handleGrade = this.handleGrade.bind(this);
        this.handleTitle1 = this.handleTitle1.bind(this);
        this.handleResearch = this.handleResearch.bind(this);
        this.handleDisability = this.handleDisability.bind(this);
        // this.handleAppChange = this.handleAppChange.bind(this);
        this.handleExcludeVid = this.handleExcludeVid.bind(this);

        this.handleSave = this.handleSave.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleAnalytics = this.handleAnalytics.bind(this);
        this.handleAppIntroduction = this.handleAppIntroduction.bind(this);
        this.closeAppIntro = this.closeAppIntro.bind(this);


    }

    componentDidMount(){
        this.setState({multipleValues:appOptions});
    }

    handleAnalytics(){
        let analytics = this.state.analytics;
        REST.addAnalytics(analytics).then(res => {});
    }

    async getMultipleValues(values) {
        this.setState({multipleValues: []});
        const valueArray = values.split(',');
        for (let i = 0; i < valueArray.length; i++){
            await this.state.multipleValues.push(getValue(appOptions, valueArray[i]));
        }
        return false;
    }

    handleName(event) {
        this.setState({ firstname: event.target.value.trim() });
    }

    handleLastName(event) {
        this.setState({ lastname: event.target.value.trim() });
    }

    handleEmail(event) {
        this.setState({email: event.target.value});
        if(event.target.value.length === 0){
            this.setState({email: null, errorEmail: '', emailWarning: '' });
        }
        else {
            if (!this.validateEmail(event.target.value)){
                this.setState({errorEmail: 'validationRed', emailWarning: 'Email address format is invalid' });
            }
            else {
                this.setState({email: event.target.value, emailWarning: '', errorEmail: ''});
            }
        }
    }

    handleReadingLevel(event) {
        this.setState({ screeningLevel: event.value });
    }

    handleLanguage(event) {
        this.setState({ language: event.value });
    }

    handleDisability(event) {
        let options = event;
        let value = [];
        if(options.length === 0){
            disabilityOptions = [
                { value: '1', label: 'None' },
                { value: '2', label: 'Deaf' },
                { value: '3', label: 'Hard of Hearing' },
                { value: '4', label: 'Blind / Visually impaired' },
                { value: '5', label: 'Learning Disability' },
                { value: '6', label: 'Behavior Challenges' },
                { value: '7', label: 'Developmental Challenges' },
                { value: '8', label: 'Physical Challenges' }
            ];
        }
        for (let i=0, l = options.length; i < l; i++){

            if(options[i].value == 1){
                disabilityOptions = [{ value: '1', label: 'None' }];
                value = [];
                value.push(1);
            }
            else{
                disabilityOptions = [
                    { value: '2', label: 'Deaf' },
                    { value: '3', label: 'Hard of Hearing' },
                    { value: '4', label: 'Blind / Visually impaired' },
                    { value: '5', label: 'Learning Disability' },
                    { value: '6', label: 'Behavior Challenges' },
                    { value: '7', label: 'Developmental Challenges' },
                    { value: '8', label: 'Physical Challenges' }
                ];
                value.push(options[i].value);
            }

        }
        this.setState({ disability: value.join(",") });
    }

    async handleExcludeVid(event) {
        this.setState({ excludeVid: event.target.checked });
        if(event.target.checked){
            appOptions = [
                { value: 'slash', label: 'Slash', isSelected: true},
                { value: 'kidspeak', label: 'KidSpeak', isSelected: true},
                { value: 'maze', label: 'Maze', isSelected: true},
                { value: 'wordmark', label: 'WordMark', isSelected: true},
            ];
            let values = [];
            for (let opt of appOptions){
                values.push(opt.value);
            }
            await this.setState({ apps: values.join(",")});
            await this.handleAppChange(appOptions);
        }
        else{
            appOptions = [
                { value: 'picturenaming', label: 'PictureNaming', isSelected: true},
                { value: 'wordsignsay', label: 'WordSign/Say', isSelected: true},
                { value: 'copyright', label: 'CopyRight', isSelected: true},
                { value: 'slash', label: 'Slash', isSelected: true},
                { value: 'kidspeak', label: 'KidSpeak', isSelected: true},
                { value: 'maze', label: 'Maze', isSelected: true},
                { value: 'kidsign', label: 'KidSign', isSelected: true},
                { value: 'wordmark', label: 'WordMark', isSelected: true},
            ];
            let values = [];
            for (let opt of appOptions){
                values.push(opt.value);
            }
            await this.setState({ apps: values.join(",")});
            await this.handleAppChange(appOptions);
        }
    }

    async handleAppChange(value) {
        let values = [];
        for (let opt of value){
            values.push(opt.value);
        }
        await this.setState({ apps: values.join(","), multipleValues: value});

    }

    handleGender(event) {
        this.setState({ gender: event.value });
    }

    handleGrade(event) {
        this.setState({ gradeLevel: event.value });
    }

    handlePlacement(event) {
        this.setState({ placement: event.value });
    }

    validateEmail(email) {
        let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    validate() {
        let valid = true;
        if (this.state.firstname === '') {
            valid = false;
            this.setState({ firstNameError:'firstNameError' });
        }
        else {
            this.setState({ firstNameError:''});
        }
        if (this.state.lastname.length === 0){
            valid = false;
            this.setState({ lastNameError:'lastNameError' });
        }
        else {
            this.setState({ lastNameError:'' });
        }
        if(!this.state.email || this.state.email === ''){
            this.setState({email: null, errorEmail: '', emailWarning: '' });
        }
        else {
            if (!this.validateEmail(this.state.email)){
                this.setState({errorEmail: 'validationRed', emailWarning: 'Email address format is invalid' });
                valid = false;
            }
            else {
                this.setState({emailWarning: '', errorEmail: ''});
            }
        }
        if (this.state.screeningLevel === null){
            valid = false;
            this.setState({ readingLevelError:'readingLevelError' });
        }
        else {
            this.setState({ readingLevelError:'' });
        }
        if (this.state.gender === null){
            valid = false;
            this.setState({ genderError:'genderError' });
        }
        else {
            this.setState({ genderError:'' });
        }
        if (this.state.language === null){
            valid = false;
            this.setState({languageError:'languageError' });
        }
        else {
            this.setState({languageError:'' });
        }
        if (this.state.disability === null || this.state.disability.length === 0) {
            valid = false;
            this.setState({ disabilityError:'disabilityError' });
        }
        else {
            this.setState({ disabilityError:'' });
        }
        if (this.state.placement === null ){
            valid = false;
            this.setState({ placementError:'placementError' });
        }
        else {
            this.setState({ placementError:'' });
        }
        if (this.state.gradeLevel === null){
            valid = false;
            this.setState({ gradeError:'gradeError' });
        }
        else {
            this.setState({ gradeError:'' });
        }
        return valid;
    }

    handleELL(event) {
        this.setState({ ell: event === null ? '-1' : event.value });
    }

    handleFreeLunch(event) {
        this.setState({ freeLunch: event === null ? '-1' : event.value });
    }

    handleSpecialEd(event) {
        this.setState({ specialNeedsData: event === null ? '-1' : event.value });
    }

    handleTitle1(event) {
        this.setState({ title1: event === null ? '-1' : event.value });
    }

    handleResearch(event) {
        this.setState({ research: !event.target.checked });
    }

    handleSave(event) {
        if (this.validate()) {
            this.setState({ errorNote: '' });

            REST.addNewStudent(this.props.classId, this.state).then((response) => {
                this.setState({
                        analytics: {
                            type: TRACKING.TEACHER_ADD_STUDENT,
                            metadata: {userId: response.body.students[0].user.id, firstName: response.body.students[0].user.firstname, lastName: response.body.students[0].user.lastname},
                        }
                    },
                    ()=> this.handleAnalytics())
                this.handleCancel();
            }, (error) => {
                console.log('Error new student', error);
            });

        }
        else{
            this.setState({ errorNote: 'Fields with red outline have to be filled in or selected!' });
        }
    }

    handleCancel(event) {
        //this.props.handleCancel();
        this.props.handleClassItemClick(this.props.class);
    }

    handleAppIntroduction(){
        this.setState({showAppIntro:true});
    }
    closeAppIntro(){
        this.setState({showAppIntro:false});
    }

    render() {
        if (!this.props.classId) {
            return <Redirect to="/login" />
        }
        return (
            <div className="col-md-9">
                <DialogBox notificationModal modalOpen={this.state.modalDialog} sectionContent={this.state.responseContent} closeClick={(active)=>{this.setState({modalDialog: active});}} />
                <ReactModal isOpen={this.state.showAppIntro} style={customStyle}>
                    <div style={{width: '100%'}}>
                        <div className="row" style={{width:250, float:'right'}}>
                            <div className="col-md-3" style={{marginTop:30}}>
                                <a  onClick={this.closeAppIntro} className="handBtn"><span>Close</span></a>
                            </div>
                            <div className="col-md-3" style={{marginLeft:50,marginTop:30}}>
                                <a  onClick={this.printAppIntro} className="handBtn" href={"https://docs.google.com/document/d/1LuRBxc0aFzkC0sLe_xvfxCXrTZxPJHD70s1WhxFMKEI/edit?usp=sharing"}><span>Print</span></a>
                            </div>
                        </div>
                    </div>
                    <div style={{marginTop:90,marginLeft:20}} >
                        <ComponentToPrint ref={el => (this.componentRef = el)} />
                    </div>
                </ReactModal>
                <h1>Add Student</h1>
                <div className="col-lg-12 solidBorder">
                    <div style={{color:'red',paddingLeft:15}}>{this.state.errorNote}</div>
                    <form id="formAddStudent">
                        <div className={"col-md-8 noPaddingLR15"}>
                            <div className="col-sm-6">
                                <div className={"form-group"}>
                                    <label htmlFor="inputStudentName">First Name</label><br/>
                                    <input type="text" value={this.state.firstName} onChange={this.handleName} id="inputStudentName" className={this.state.firstNameError + " form-control inputStyle1"} placeholder="First Name" required autoFocus />
                                </div>
                                <div className={"form-group"}>
                                    <label htmlFor="inputStudentLastName">Last Name</label>
                                    <input type="text" value={this.state.lastName} onChange={this.handleLastName} id="inputStudentLastName" className={this.state.lastNameError + " form-control inputStyle1"} placeholder="Last Name" required />
                                </div>
                                <div className={"form-group"}>
                                    <label htmlFor="inputStudentReadingLevel">Reading Level</label>
                                    <OverlayTrigger placement="top" overlay={tooltipReadingLevel}>
                                        <Select className={this.state.readingLevelError}  onChange={this.handleReadingLevel} id="inputStudentReadingLevel"  options={readingLevelOptions} isSearchable={false} />
                                    </OverlayTrigger>
                                </div>
                                <div className={"form-group"}>
                                    <label htmlFor="inputStudentGender">Gender</label>
                                    <Select className={this.state.genderError}  onChange={this.handleGender} id="inputStudentGender" options={genderOptions} isSearchable={false} />
                                </div>
                            </div>
                            <div className="col-sm-6">
                                <div className={"form-group"}>
                                    <label htmlFor="inputStudentLanguage">Language</label>
                                    <Select className={this.state.languageError}  onChange={this.handleLanguage} id="inputStudentLanguage" options={languageOptions} isSearchable={false} />
                                </div>
                                <div className={"form-group"}>
                                    <label htmlFor="inputStudentDisability">Student Description</label>
                                    <OverlayTrigger placement="top" overlay={tooltipDisability}>
                                        <Select className={"basic-multi-select " + this.state.disabilityError} onChange={this.handleDisability} id="inputStudentDisability" options={disabilityOptions} isMulti={true} isSearchable={false} />
                                    </OverlayTrigger>
                                </div>
                                <div className={"form-group"}>
                                    <label htmlFor="inputStudentPlacement">Placement</label>
                                    <Select className={this.state.placementError} onChange={this.handlePlacement} id="inputStudentPlacement" options={placementOptions} isSearchable={false} />
                                </div>
                                <div className={"form-group"}>
                                    <label htmlFor="inputStudentGrade">Grade Placement</label>
                                    <Select className={this.state.gradeError} onChange={this.handleGrade} id="inputStudentGrade" options={gradeOptions} isSearchable={false} />
                                </div>
                            </div>
                            <div className={"col-md-12"}>
                                <div className={"form-group"}>
                                    <div className="row">
                                        <div className="col-sm-3">
                                            <label htmlFor="inputStudentGrade">Task Apps</label>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-6" style={{height:40,marginTop:-30, marginLeft:80, cursor:'pointer'}} >
                                            <img src={info_icon_2f} style={{width:22, height:22}} onClick={this.handleAppIntroduction}/>
                                            <a target="_blank" href={"https://docs.google.com/document/d/1LuRBxc0aFzkC0sLe_xvfxCXrTZxPJHD70s1WhxFMKEI/edit?usp=sharing"} style={{fontFamily:'Open Sans', fontSize:'1.00em'}} name="How" className="btn btn-link" >How to Select Apps</a>
                                        </div>
                                    </div>
                                    <Select className="basic-multi-select" isMulti={true}  options={appOptions}  value={this.state.multipleValues} isSearchable={false} onChange={this.handleAppChange.bind(this)} />

                                </div>
                            </div>
                        </div>
                        <div className="col-sm-4" >
                            <div className={"form-group"}>
                                <div style={{color:'red'}}>{this.state.emailWarning}</div>
                                <label htmlFor="inputStudentEmail">Parent Email (Optional)</label>
                                <input type="text" defaultValue={this.state.email} onChange={this.handleEmail} id="inputStudentEmail" className={this.state.errorEmail + ' form-control inputStyle1'} placeholder="Email" />
                            </div>

                            <label htmlFor="inputStudentIEP">IEP (Optional)</label>
                            <Select  onChange={this.handleSpecialEd} id="inputStudentSpecialEd"  defaultValue={getFourValue(fourValueOptions, this.state.specialNeedsData)} options={fourValueOptions} isSearchable={false} isClearable={true}/>
                            <label htmlFor="inputStudentELL">ELL (Optional)</label>
                            <Select  onChange={this.handleELL} id="inputStudentELL"  defaultValue={getFourValue(fourValueOptions, this.state.ell)} options={fourValueOptions} isSearchable={false} isClearable={true}/>
                            <label htmlFor="inputStudentFreeLunch">Free Lunch (Optional)</label>
                            <Select  onChange={this.handleFreeLunch} id="inputStudentFreeLunch"  defaultValue={getFourValue(fourValueOptions, this.state.freeLunch)} options={fourValueOptions} isSearchable={false} isClearable={true}/>
                            <label htmlFor="inputStudentTitle1">Title 1 (Optional)</label>
                            <Select  onChange={this.handleTitle1} id="inputStudentTitle1"  defaultValue={getFourValue(fourValueOptions, this.state.title1)} options={fourValueOptions} isSearchable={false} isClearable={true}/><br />

                            <label htmlFor="Research" className="cb"><input type="checkbox" onChange={this.handleResearch} name="Research" value={!this.state.research} id="Research" /><span className="checkmark"></span> Exclude Student Data</label><br />
                            <label htmlFor="ExcludeVideoApps" className="cb" style={{marginBottom:0}}><input type="checkbox" onChange={this.handleExcludeVid} name="ExcludeVideoApps" value={this.state.excludeVid} id="ExcludeVideoApps" /><span className="checkmark"></span> Exclude Video Apps</label><br />
                        </div>
                    </form>
                    <div className="clearfix" ></div>
                    <div className="divBottomRelative tr">
                        {/*<p className="text-left">Note: Fields with * are required fields</p>*/}
                        {/*<hr />*/}
                        <a onClick={this.handleCancel} className="handBtn">
                            <span>Cancel</span>
                        </a>
                        <a onClick={() => { this.handleSave() } } className="handBtn">
                            <span>Save Changes</span>
                        </a>
                    </div>
                </div>
            </div >
        )
    }
}
const AddStudent = withRouter(AddStudentComponent);

class StudentsList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            students: this.props.students,
            showAddStudentHint:true,
            analytics: {
                type: null,
                metadata: null,
            }};
        this.sortStudentsByName = this.sortStudentsByName.bind(this);
        this.sortStudentsByUserId = this.sortStudentsByUserId.bind(this);
        this.handleItemClick = this.handleItemClick.bind(this);
        this.handleClassTab = this.handleClassTab.bind(this);
        this.handleAddStudent = this.handleAddStudent.bind(this);
        this.handleAddStudentHint = this.handleAddStudentHint.bind(this);
        this.getTarget = this.getTarget.bind(this);
        this.handleAnalytics = this.handleAnalytics.bind(this);
    }
    componentDidMount(){
        if(localStorage.getItem('addStudent') === 'hide'){
            this.setState({showAddStudentHint: false})
        }
    }

    sortStudentsByUserId(){
        this.setState ({
            students: this.state.students.sort((a,b) =>
                ((a.userId > b.userId) ? 1 : ((a.userId < b.userId) ? -1 : 0))
            )
        });
    }

    sortStudentsByName(){
        this.setState ({
            students: this.state.students.sort((a,b) =>{
                let nameA = a.user.firstname + ' ' + a.user.lastname;
                let nameB = b.user.firstname + ' ' + b.user.lastname;
                return  ((nameA > nameB) ? 1 : ((nameA < nameB) ? -1 : 0));

            })
        });

    }

    handleAddStudentHint(){
        this.setState({showAddStudentHint: !this.state.showAddStudentHint})
    }
    getTarget() {
        return ReactDOM.findDOMNode(this.target);
    }

    handleClassTab(event) {
        this.props.handleClassTab();
    }

    handleAnalytics(){
        let analytics = this.state.analytics;
        REST.addAnalytics(analytics).then(res => {});
    }

    handleItemClick = async (student) => {
        await this.setState({
                analytics:{
                    type:TRACKING.TEACHER_STUDENT_DETAILS_VIEW,
                    metadata:{userId: student.userId}
                }
            },
            () => {this.handleAnalytics();this.props.handleItemClick(student, this.props.classId);}  );
    };

    handleAddStudent(event) {
        this.props.handleAddStudent();
        this.handleAddStudentHint();
        localStorage.setItem('addStudent', 'hide');
        event.preventDefault();
    }

    render() {
        const sharedProps = {
            container: this,
            target: this.getTarget,
            show: this.state.showAddStudentHint
        };
        let items = this.state.students;
        let students = items.map((student) => {
            return <StudentListItem key={student.id} student={student} handleClick={this.handleItemClick} deleteStudent={this.props.deleteStudent}/>
        });
        return (
            <div>
                <a ref={button => {
                    this.target = button;
                }} className="fr">
                    <img src={ico_plus_green} onClick={this.handleAddStudent} style={{cursor:'pointer'}} alt="Add a Student" border="0" className="ico-xs ico-add" />
                </a>
                {
                    addStudentStorage !== 'hide' ?
                        <Overlay {...sharedProps} placement="left">
                            <Popover id="popover-positioned-top" title="Step 2">
                                Add a Student(s)
                            </Popover>
                        </Overlay>
                        :
                        null
                }
                <ul className="nav nav-tabs">
                    <li className="active" onClick={this.handleStudentsTab}><a data-toggle="tab">Students</a></li>
                    <li onClick={this.handleClassTab}><a data-toggle="tab">Class Info</a></li>
                    <li onClick={this.props.handleMultipleStudentsTab}><a data-toggle="tab">Share/Transfer Students</a></li>
                </ul>
                <div className="tab-pane active solidBorder noPadding">
                    <table cellPadding="0" cellSpacing="0" border="0" width="100%">
                        <thead>
                        <tr className="clickable-row">
                            <th className="fitWidth">#</th>
                            <th><a onClick={this.sortStudentsByName}>Full Name</a></th>
                            <th className="fitWidth"><a onClick={this.sortStudentsByUserId}>User Number</a></th>
                            <th className="fitWidth">Password</th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        {students}
                        </tbody>
                    </table>
                </div>
            </div >
        );
    }
}
const Students = withRouter(StudentsList);

class StudentListItem extends Component {
    constructor(props) {
        super(props);
        this.state = {modalDialog:false, responseContent:''}
        this.handleClick = this.handleClick.bind(this);
        this.deleteStudent = this.deleteStudent.bind(this);
    }

    handleClick(event) {
        this.props.handleClick(this.props.student);
        event.stopPropagation();
    }

    deleteStudent = (confirm) => {
        if(confirm) {
            this.props.deleteStudent(this.props.student);
        }
    }

    render() {
        let student = this.props.student;
        return (
            <tr className="clickable-row">
                <DialogBox
                    modalOpen={this.state.modalDialog}
                    confirmDelete={this.deleteStudent}
                    sectionContent={this.state.responseContent}
                    closeClick={(active)=>{this.setState({modalDialog: active});}}
                />
                <td onClick={(event)=>{this.setState({modalDialog:true,responseContent:'ARE YOU SURE YOU WANT TO DELETE THIS STUDENT?'});   event.stopPropagation();}}>
                    <input
                        style={{maxHeight:30}}
                        type="image"
                        alt={"Delete"}
                        src={require("../assets/images/ico-trash.png")}

                    />
                </td>
                <td onClick={this.handleClick}>{student.user.firstname} {student.user.lastname}</td>
                <td onClick={this.handleClick}>{student.userId}</td>
                <td onClick={this.handleClick}>{student.user.password}</td>
                <td className="fitWidth" onClick={this.handleClick}>
                    <a>
                        <img src={ico_view} alt="View Student Details" border="0" className="ico-xs" />
                    </a>
                </td>
            </tr>
        )
    }
}

class MultipleStudentsList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showAddStudentHint:true,
            showTeacherInfo: false,
            showClassList: false,
            allChecked: false,
            checkList: [],
            studentIds: [],
            students: this.props.students,
            analytics: {
                type: null,
                metadata: null,
            }};
        this.sortStudentsByName = this.sortStudentsByName.bind(this);
        this.sortStudentsByUserId = this.sortStudentsByUserId.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.handleClassTab = this.handleClassTab.bind(this);
        this.handleContinue = this.handleContinue.bind(this);
        this.handleAllChecked = this.handleAllChecked.bind(this);
        this.handleCancelTransfer = this.handleCancelTransfer.bind(this);
    }
    componentDidMount(){
        let students = this.props.students;
        let checkList = [];
        students.forEach((student) => {
            checkList.push ({studentId: student.id, checked: false});
        });
        this.setState({checkList:checkList});
    }

    handleClassTab(event) {
        this.props.handleClassTab();
    }

    sortStudentsByUserId(){
        this.setState ({
            students: this.state.students.sort((a,b) =>
                ((a.userId > b.userId) ? 1 : ((a.userId < b.userId) ? -1 : 0))
            )
        });
    }

    sortStudentsByName(){
        this.setState ({
            students: this.state.students.sort((a,b) =>{
                let nameA = a.user.firstname + ' ' + a.user.lastname;
                let nameB = b.user.firstname + ' ' + b.user.lastname;
                return  ((nameA > nameB) ? 1 : ((nameA < nameB) ? -1 : 0));

            })
        });

    }

    handleSelect = async (studentId, isChecked) => {
        let checkList = this.state.checkList;
        for(let i=0; i<checkList.length; i++){
            if(checkList[i].studentId == studentId){
                checkList[i].checked = isChecked;
            }
        }
        let studentIds = [];
        for(let i=0; i<checkList.length; i++){
            if(checkList[i].checked){
                studentIds.push(checkList[i].studentId);
            }
        }
        this.setState({checkList:checkList, studentIds:studentIds});
    };

    handleContinue(){
        this.setState({
            showTeacherInfo:true
        })
    }

    handleAllChecked(){
        let newCheckStatus = !this.state.allChecked;
        let students = this.state.students;
        let checkList = [];
        students.forEach((student) => {
            if (newCheckStatus) {
                checkList.push({studentId: student.id, checked: true});
            }else{
                checkList.push({studentId: student.id, checked: false});
            }
        });

        let studentIds = [];
        for(let i=0; i<checkList.length; i++){
            if(checkList[i].checked){
                studentIds.push(checkList[i].studentId);
            }
        }

        this.setState({
            studentIds: studentIds,
            checkList: checkList,
            allChecked: newCheckStatus
        })
    }

    handleCancelTransfer(){
        this.setState({
            showTeacherInfo: false
        });
    }

    render() {
        const sharedProps = {
            container: this,
            target: this.getTarget,
            show: this.state.showAddStudentHint
        };
        let items = this.state.students;
        let students = items.map((student) => {
            return <MultipleStudentListItem key={student.id} student={student} checked={getChecked(this.state.checkList, student.id)} handleSelect={this.handleSelect} />
        });
        return (
            <div>
                <ul className="nav nav-tabs">
                    <li onClick={this.props.handleStudentsTab}><a data-toggle="tab">Students</a></li>
                    <li onClick={this.handleClassTab}><a data-toggle="tab">Class Info</a></li>
                    <li className="active" onClick={this.handleMultipleStudentsTab}><a data-toggle="tab">Share/Transfer Students</a></li>
                </ul>
                <div className="tab-pane active solidBorder noPadding">
                    <p>You can share or transfer students to another teacher.</p>
                    <p>Step 1: Select the students to share or transfer</p>
                    <table cellPadding="0" cellSpacing="0" border="0" width="100%">
                        <thead>
                        <tr className="clickable-row">
                            <th className="fitWidth">
                                <input type="checkbox" onChange={this.handleAllChecked} name="selectStudent" checked={this.state.allChecked} id="allChecked" />
                            </th>
                            <th><a onClick={this.sortStudentsByName}>Full Name</a></th>
                            <th className="fitWidth"><a onClick={this.sortStudentsByUserId}>User Number</a></th>
                        </tr>
                        </thead>
                        <tbody>
                        {students}
                        </tbody>
                    </table>
                </div>
                <div className="divBottomRelative tr">
                    <a onClick={this.handleContinue} className="handBtn">
                        <span>Continue</span>
                    </a>
                </div>
                {this.state.showTeacherInfo?<div>
                    <TransferStudentComponent schoolAdmin={this.props.schoolAdmin} studentIds={this.state.studentIds} handleCancelTransfer={this.handleCancelTransfer} />
                </div>:null
                }
            </div >
        );
    }
}
const MultipleStudents = withRouter(MultipleStudentsList);

class MultipleStudentListItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isSelected: this.props.checked
        }
        this.handleSelectStudent = this.handleSelectStudent.bind(this);
    }

    componentDidUpdate(oldProps){
        const newProps = this.props;
        if(oldProps.checked !== newProps.checked){
            this.setState({ isSelected: newProps.checked});
        }
    }

    handleSelectStudent = async (studentId) => {
        await this.setState({
            isSelected: !this.state.isSelected
        });
        this.props.handleSelect(studentId,this.state.isSelected);

    }

    render() {
        let student = this.props.student;
        return (
            <tr className="clickable-row">
                <td>
                    <input type="checkbox" onChange={()=>this.handleSelectStudent(student.id)} name="selectStudent" checked={this.state.isSelected} id="checkSelected" />
                </td>
                <td onClick={()=>this.handleSelectStudent(student.id)} >{student.user.firstname} {student.user.lastname}</td>
                <td onClick={()=>this.handleSelectStudent(student.id)}>{student.userId}</td>
            </tr>
        )
    }
}

const TransferStudentComponent = withRouter(class TransferStudentComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            teacherId: 0,
            classId: 0,
            studentId: this.props.studentId,
            studentIds: this.props.studentIds,
            classes: [],
            share: false,
            modalDialog:false,
            responseContent: '',
            modalInfoDialog:false,
            responseInfoContent:''
        };
        this.handleDone = this.handleDone.bind(this);
        this.handleCancelTransfer = this.handleCancelTransfer.bind(this);
        this.handleBackClick = this.handleBackClick.bind(this);
    }

    componentDidUpdate(oldProps){
        const newProps = this.props;
        if(oldProps.studentIds !== newProps.studentIds){
            this.setState({ studentIds: newProps.studentIds});
        }
    }

    handleBackClick = () => {
        if(this.props.schoolAdmin){
            this.props.history.push("/school-admin");
        }else {
            this.props.history.push("/teacher");
        }
    }

    handleCorrectTeacherData = (data) => {
        this.setState({ teacherId: data.teacher.id, classes: data.teacher.classes });
    };

    handleCancelTransfer = () => {
        this.props.handleCancelTransfer();
    };

    handleClassSelect = (classId) => {
        this.setState({ classId: parseInt(classId) });
    };

    async handleDone(event,share) {
        if(this.state.classId>0) {
            let promptText;
            if (share) {
                promptText = 'Are you sure you wish to share the students?';
            } else {
                promptText = 'Are you sure you wish to transfer the students?';
            }
            if (window.confirm(promptText)) {
                await this.setState({share: share});
                REST.transferMultipleStudents(this.state).then((response) => {
                    this.setState({
                        modalDialog: true,
                        responseContent: this.state.share ? 'Student has been shared Successfully!' : 'Student has been transferred Successfully!'
                    });
                }, (error) => {
                    console.log(`transfer student error`, error);
                });
            }
        }else{
            this.setState({
                modalInfoDialog: true,
                responseInfoContent:  'Step 3:In the drop down list, select a class into which the student will be placed!'
            });
        }
    }

    render() {
        return (
            <div className="col-lg-12 solidBorder">
                <DialogBox notificationModal modalOpen={this.state.modalDialog} sectionContent={this.state.responseContent} closeClick={(active)=>{this.setState({modalDialog: active}); window.location.reload()}} />
                <DialogBox notificationModal modalOpen={this.state.modalInfoDialog} sectionContent={this.state.responseInfoContent} closeClick={(active)=>{this.setState({modalInfoDialog: false})}} />
                <TeacherInfoTransferComponent correctTeacherData={this.handleCorrectTeacherData} handleCancelTransfer={this.handleCancelTransfer} />
                {this.state.classes && this.state.classes.length > 0 ?
                    <div>
                        <TeacherClassTransferComponent classes={this.state.classes} handleClassSelect={this.handleClassSelect} />
                        <div className="clearfix"></div>
                        <div className="divBottomRelative">
                            <hr />
                            <a onClick={this.handleCancelTransfer} className="handBtn">
                                <span>Cancel</span>
                            </a>
                            <a onClick={(e)=>this.handleDone(e,false)} disabled={this.state.classId === 0} className="handBtn">
                                <span>Transfer</span>
                            </a>
                            <a onClick={(e)=>this.handleDone(e,true)} disabled={this.state.classId === 0} className="handBtn">
                                <span>Share</span>
                            </a>
                        </div>
                    </div> :null
                }
            </div>
        )
    }
});

class TeacherInfoTransferComponent extends Component {

    constructor(props) {
        super(props);
        this.state = { firstName: '', lastName: '', teacherId: '', hideButtons: false, modalDialog:false, responseContent:'' };
        this.handleFirstName = this.handleFirstName.bind(this);
        this.handleLastName = this.handleLastName.bind(this);
        this.handleLoginID = this.handleLoginID.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleContinue = this.handleContinue.bind(this);
    }

    handleFirstName(event) {
        this.setState({ firstName: event.target.value.replace(/\s+/g, '') });
    }

    handleLastName(event) {
        this.setState({ lastName: event.target.value.replace(/\s+/g, '') });
    }

    handleLoginID(event) {
        event.target.value = event.target.value.replace(/[^0-9.]+/g, '');
        this.setState({ teacherId: event.target.value });
    }

    validate(){
        let valid = true;
        if (this.state.firstName.length === 0) {
            valid = false;
            document.getElementById("inputTeacherName").classList.add('validationRed');

        } else {
            document.getElementById("inputTeacherName").classList.remove('validationRed');
        }
        if (this.state.lastName.length === 0) {
            valid = false;
            document.getElementById("inputTeacherLastName").classList.add('validationRed');
        } else {
            document.getElementById("inputTeacherLastName").classList.remove('validationRed');
        }
        if (this.state.teacherId.length === 0 || this.state.teacherId === null) {
            valid = false;
            document.getElementById("inputTeacherLoginID").classList.add('validationRed');
        }
        else {
            document.getElementById("inputTeacherLoginID").classList.remove('validationRed');
        }
        return valid;

    }

    handleContinue(event) {
        if (this.validate()) {
            document.getElementById("validWarning").classList.add("hidden");
            this.listExternalTeacher();
        }
        else {
            document.getElementById("validWarning").classList.remove("hidden");
        }
    }

    listExternalTeacher() {
        REST.listExternalTeacher(this.state).then((response) => {
            if (response.success && response.body) {
                this.props.correctTeacherData(response.body);
                this.setState({ hideButtons: true });
            } else if (response.success){
                this.setState({
                    modalDialog: true,
                    responseContent:'This teacher doesn\'t have any classes.'
                });
            }else{
                this.setState({
                    modalDialog: true,
                    responseContent:'Incorrect input! Check it and retry!'
                });
            }

        }, (error) => {
            console.log('Error', error);
        });
    }

    handleCancel(event) {
        this.props.handleCancelTransfer();
    }

    render() {
        return (
            <div>
                <DialogBox notificationModal modalOpen={this.state.modalDialog} sectionContent={this.state.responseContent} closeClick={(active)=>{this.setState({modalDialog: active});}} />
                <p>Step 2: Share/ transfer students with a teacher</p>
                <p>Enter the new teacher's first name, last name and user number for AvePM. Then you will be asked to select the new class name for the students.
                </p>
                <form>
                    <div id={"validWarning"} className={"hidden"} style={{color:'red',paddingBottom:10}}> Fields with red outline have to be filled in or selected!</div>
                    <label htmlFor="inputTeacherName">Teacher First Name</label>
                    <input type="text" onChange={this.handleFirstName} id="inputTeacherName" className="form-control " placeholder="First Name" required autoFocus />
                    <label htmlFor="inputTeacherLastName">Teacher Last Name</label>
                    <input type="text" onChange={this.handleLastName} id="inputTeacherLastName" className="form-control " placeholder="Last Name" required />
                    <label htmlFor="inputTeacherLoginID">Teacher User Number</label>
                    <input type="text" onInput={this.handleLoginID} id="inputTeacherLoginID" className="form-control " placeholder="User Number" required />
                </form>
                <div className="clearfix"></div>
                {this.state.hideButtons ? null :
                    <div className="divBottomRelative">
                        <hr />
                        <a onClick={this.handleCancel} className="handBtn">
                            <span>Cancel</span>
                        </a>
                        <a onClick={this.handleContinue} className="handBtn">
                            <span>Continue</span>
                        </a>
                    </div>
                }
            </div>
        )
    }
}

class TeacherClassTransferComponent extends Component {
    constructor(props) {
        super(props);
        this.state = { classes: this.props.classes || [] };
        this.handleClassSelect = this.handleClassSelect.bind(this);
    }

    handleClassSelect(event) {
        this.props.handleClassSelect(event.value);
    }

    render() {
        let options = [];
        options[0] = <option key={0} value={0}>Select a class</option>
        for (var i = 0; i < this.state.classes.length; i++) {
            let c = this.state.classes[i];
            // ///options[i + 1] = <option key={c.id} value={c.id}>{c.name}</option>;
            options.push({ value: c.id, label: c.name});
        }
        return (
            <div>
                <p style={{marginTop:5}}>Step 3: In the drop down list, select a class into which the student will be placed.</p>
                <Select onChange={this.handleClassSelect} id="classes" name="classes"   options={options} isSearchable={false} />
            </div>
        )
    }
}

class AddClassComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            name: this.props.class ? this.props.class.name : "", confirmDelete:false
        };
        this.handleName = this.handleName.bind(this);
        this.handleGrade = this.handleGrade.bind(this);
        this.handleSemester = this.handleSemester.bind(this);
        this.handleYear = this.handleYear.bind(this);

        this.handleSave = this.handleSave.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.deleteClass = this.deleteClass.bind(this);
        this.handleAnalytics = this.handleAnalytics.bind(this);

    }

    handleAnalytics(){
        let analytics = this.state.analytics;
        REST.addAnalytics(analytics).then(res => {});
    }

    handleName(event) {
        this.setState({ name: event.target.value });
    }

    handleGrade(event) {
        this.setState({ grade: event.target.value });
    }

    handleSemester(event) {
        this.setState({ semester: event.target.value });
    }

    handleYear(event) {
        this.setState({ year: event.target.value });
    }

    handleSave(event) {
        if (!this.state.name) {
            this.setState({
                modalDialog: true,
                responseContent:'Must enter class name'

            });
            setTimeout(()=>{this.setState({modalDialog:false})},3500);
            return;
        }
        if (this.props.edit) {
            let body = { classId: this.props.class.id, name: this.state.name };
            REST.updateClass(body).then((response) => {
                if (response.success) {
                    this.props.saveClassCallback(response.body);
                } else {
                    this.setState({
                        modalDialog: true,
                        responseContent:'Please input another class name.'

                    });
                    //setTimeout(()=>{this.setState({modalDialog:false})},3500);
                }
            }, (error) => {
                console.log('Add new class error', error);
                this.setState({
                    modalDialog: true,
                    responseContent:'Please input another class name.'

                });
                //setTimeout(()=>{this.setState({modalDialog:false})},3500);
            });
        }
        else {
            let body = { name: this.state.name };
            REST.addNewClass(body).then((response) => {
                if (response.success) {
                    this.props.saveClassCallback(response.body);
                } else {
                    this.setState({
                        modalDialog: true,
                        responseContent:'Please input another class name.'

                    });
                    //setTimeout(()=>{this.setState({modalDialog:false})},3500);
                }
            }, (error) => {
                console.log('Add new class error', error);
                this.setState({
                    modalDialog: true,
                    responseContent:'Please input another class name.'

                });
                //setTimeout(()=>{this.setState({modalDialog:false})},3500);
            });
        }
        event.preventDefault();
    }

    handleCancel() {
        this.props.cancelCallback();
    }

    handleDelete() {
        REST.deleteClass(this.props.class.id).then((response) => {
            if (response.success) {
                this.setState({
                        analytics: {
                            type: TRACKING.TEACHER_DELETED_CLASS,
                            metadata: {classId: this.props.class.id},
                        }
                    },
                    ()=>this.handleAnalytics())
                this.props.saveClassCallback(response.body);
            }
            else {
                this.setState({
                    modalDialog: true,
                    responseContent:response.msg

                });

                setTimeout(()=>{this.setState({modalDialog:false})},3500);
            }
        }, (error) => {
            console.log('Delete class error', error);
        });
    }

    deleteClass = (confirm) => {
        if(confirm){
            this.handleDelete();
        }
    }

    render() {
        return (
            <div className="col-lg-12 solidBorder hasfitWidth"><DialogBox notificationModal modalOpen={this.state.modalDialog} sectionContent={this.state.responseContent} closeClick={(active)=>{this.setState({modalDialog: active});}} />
                <form id="formAddClass">
                    <label htmlFor="inputClassName">Class Name</label>
                    <input type="text" onChange={this.handleName} id="inputClassName" value={this.state.name} className="form-control" placeholder="Class Name" required autoFocus />
                </form>
                <hr/>
                {!this.props.edit ?
                    (<div className="nav navbar fr">
                        <a onClick={this.handleCancel} className="handBtn">
                            <span>Cancel</span>
                        </a>
                        <a onClick={this.handleSave} className="handBtn">
                            <span>Save Changes</span>
                        </a>
                    </div>) :
                    (<div className="nav navbar fr">
                        <DialogBox
                            modalOpen={this.state.modalDialog}
                            confirmDelete={this.deleteClass}
                            sectionContent={this.state.responseContent}
                            closeClick={(active)=>{this.setState({modalDialog: active});}}
                        />
                        <a onClick={()=>{this.setState({modalDialog:true,responseContent:'ARE YOU SURE YOU WANT TO DELETE THIS CLASS?'})}} className="handBtn fl">
                            <span>Delete Class</span>
                        </a>
                        <a onClick={this.handleCancel} className="handBtn">
                            <span>Cancel</span>
                        </a>
                        <a onClick={this.handleSave} className="handBtn">
                            <span>Save Changes</span>
                        </a>
                    </div>)}

            </div>
        );
    }
}

export class ClassListComponent extends Component {

    handleItemClick = (object) => {
        this.props.handleItemClick(object);
    };

    render() {
        let items = this.props.classes;
        const classes = items.map((item) => {
            return <ClassItemComponent key={item.id} item={item} active={this.props.clickedClassID===item.id ? "active":""} handleClick={this.handleItemClick} deleteClass={this.props.deleteClass}/>
        });
        return (
            <table cellPadding="0" cellSpacing="0" border="0" width="100%">
                <tbody>
                {classes}
                </tbody>
            </table>
        );
    }
}

class ClassItemComponent extends Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
        this.deleteClass = this.deleteClass.bind(this);
    }

    handleClick(event) {
        this.props.handleClick(this.props.item);
        event.preventDefault();
    }

    deleteClass(event){
        let confirmed = window.confirm("Are you sure that you want to delete this class ?");
        if(confirmed) {
            this.props.deleteClass(this.props.item);
        }
        event.stopPropagation();
    }

    render() {
        return (
            <tr className={"clickable-row "+this.props.active} onClick={this.handleClick}>
                <td>{this.props.item.name}</td>
                <td className="fitWidth">
                    <a>
                        <img src={ico_view} alt="View Class Students" border="0" className="ico-xs" />
                    </a>
                </td>
                {/*<td>*/}
                {/*<input*/}
                {/*onClick={(e)=>this.deleteClass(e)}*/}
                {/*style={{maxHeight:25}}*/}
                {/*type="image"*/}
                {/*alt={"Delete"}*/}
                {/*src={require("../assets/images/ico-trash.png")}*/}
                {/*/>*/}
                {/*</td>*/}
            </tr>
        );
    }
}

const bindActionToProps = dispatch => {
    return {
        selectClass: async(selectedClass) => await dispatch(selectClass(selectedClass)),
        updateStudent: async(selectedStudent) => await dispatch(updateStudent(selectedStudent)),
        updateTeacher: async(data) => await dispatch(updateTeacher(data)),
        userLogout: async() => await dispatch(userLogout())
    };
};


const mapStateToProps = state => ({
    lastClass: state.teacherReducer.lastClass,
    lastStudent: state.teacherReducer.student,
    teacher: state.teacherReducer.teacher
});


export default connect(mapStateToProps,bindActionToProps)(withRouter(MainTeacherComponent));




// WEBPACK FOOTER //
// ./src/TeachersComponent/Main.js